webpackJsonp([230],{

/***/ 1088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaiWangCfgForm_vue__ = __webpack_require__(2680);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c6b45ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaiWangCfgForm_vue__ = __webpack_require__(4030);
function injectStyle (ssrContext) {
  __webpack_require__(4024)
  __webpack_require__(4026)
  this["$style"] = __webpack_require__(4028)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c6b45ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaiWangCfgForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c6b45ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaiWangCfgForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return companyFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return companyAccountFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return finCenterConfigRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return departmentJobFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return invoiceNameAddRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return invoiceNameEditRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baiWangCfgForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入正确的财务中心设置ID', 'integer', 'blur', false), { min: 1 })]
};

var formRules = {
  payment_apply_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择付款类型', 'integer'))],
  first_subject_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择一级科目', 'integer'))]
};

var companyFormRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入公司名称'))],
  finance_ids: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择财务负责人', 'array'))],
  kingdee_number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入金蝶编码'))]
};

var companyAccountFormRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入账户名称'))],
  our_company_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择公司', 'integer'))],
  number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入银行卡号'))],
  bank_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择开户银行', 'integer'))]
};

var finCenterConfigRules = {
  approve_amount_lv1: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入一级审批起始值', 'integer', 'blur', true), { min: 0 })],
  approve_amount_lv2: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入二级审批起始值', 'integer', 'blur', true), { min: 0 })],
  approve_amount_lv3: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入三级审批起始值', 'integer', 'blur', true), { min: 0 })],
  approve_amount_lv4: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入四级审批起始值', 'integer', 'blur', true), { min: 0 })]
};

var departmentJobFormRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入部门岗位名称'))]
};

var invoiceNameAddRule = {
  tax_rate: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入税率，范围 0-100', 'integer'))],
  product_num: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入商品编码', 'string'))],
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入开票名称', 'string'))],
  type_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择开票名称类别', 'integer'))]
};

var invoiceNameEditRule = {
  tax_rate: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入税率，范围 0-100', 'integer'))],
  product_num: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入商品编码', 'string'))]
};

var baiWangCfgForm = {
  tax_panel_pwd: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('税控盘口令 不能为空', 'string'))],
  digital_cert_pwd: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('数字证书密码 不能为空', 'string'))],
  bw_register_code: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('百旺注册码 不能为空', 'string'))],
  address_and_phone: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('销货地址单位及电话 不能为空', 'string'))],
  bank_acct: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('销货单位银行帐号 不能为空', 'string'))],
  code_version_number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('百旺编码版本号 不能为空', 'string'))],
  ticket_payee: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('收款人 不能为空', 'string'))],
  ticket_reviewer: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('复核人 不能为空', 'string'))]
};

/***/ }),

/***/ 2680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__finance_config_rules_js__ = __webpack_require__(1506);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [],
  components: {},
  data: function data() {
    return {
      baiWangCfgForm: __WEBPACK_IMPORTED_MODULE_2__finance_config_rules_js__["a" /* baiWangCfgForm */],
      form: {
        'tax_panel_pwd': '',
        'digital_cert_pwd': '',
        'bw_register_code': '',
        'address_and_phone': '中国（上海）自由贸易试验区临港新片区海基六路218弄12号2楼 021-50596822',
        'bank_acct': '工商银行上海市金陵东路支行 1001268909016809212',
        'code_version_number': '40.0',
        'ticket_payee': '',
        'ticket_reviewer': ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({})),
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  created: function created() {
    this.getCfg();
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    onLoad: function onLoad() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    onReload: function onReload() {
      this.onLoad();
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.saveCfg();
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    saveCfg: function saveCfg() {
      var _this2 = this;

      request.common('saveBaiWangCfg', _.cloneDeep(this.form)).then(function (res) {
        _this2.$confirm('设置保存成功', '提示', { type: 'success' });
      });
    },
    getCfg: function getCfg() {
      var _this3 = this;

      request.common('getBaiWangCfg').then(function (_ref) {
        var data = _ref.data;

        for (var key in _this3.form) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            _this3.form[key] = data[key];
          }
        }
      });
    }
  })
});

/***/ }),

/***/ 4024:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("18b36d1a", content, true, {});

/***/ }),

/***/ 4025:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"BaiWangCfgForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4026:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4027);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2d2817e8", content, true, {});

/***/ }),

/***/ 4027:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"BaiWangCfgForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4028:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4029);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5f511564", content, true, {});

/***/ }),

/***/ 4029:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"BaiWangCfgForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("财务中心设置")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.baiWangCfgForm,"size":"medium","label-width":"180px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"税控盘口令","prop":"tax_panel_pwd"}},[_c('el-input',{attrs:{"placeholder":"请输入税控盘口令"},model:{value:(_vm.form.tax_panel_pwd),callback:function ($$v) {_vm.$set(_vm.form, "tax_panel_pwd", $$v)},expression:"form.tax_panel_pwd"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"数字证书密码","prop":"digital_cert_pwd"}},[_c('el-input',{attrs:{"placeholder":"请输入数字证书密码"},model:{value:(_vm.form.digital_cert_pwd),callback:function ($$v) {_vm.$set(_vm.form, "digital_cert_pwd", $$v)},expression:"form.digital_cert_pwd"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"百旺注册码","prop":"bw_register_code"}},[_c('el-input',{attrs:{"placeholder":"请输入百旺注册码"},model:{value:(_vm.form.bw_register_code),callback:function ($$v) {_vm.$set(_vm.form, "bw_register_code", $$v)},expression:"form.bw_register_code"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"销货地址单位及电话","prop":"address_and_phone"}},[_c('el-input',{attrs:{"placeholder":"请输入 销货地址单位及电话"},model:{value:(_vm.form.address_and_phone),callback:function ($$v) {_vm.$set(_vm.form, "address_and_phone", $$v)},expression:"form.address_and_phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"销货单位银行帐号","prop":"bank_acct"}},[_c('el-input',{attrs:{"placeholder":"请输入 销货单位银行帐号"},model:{value:(_vm.form.bank_acct),callback:function ($$v) {_vm.$set(_vm.form, "bank_acct", $$v)},expression:"form.bank_acct"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"百旺编码版本号","prop":"code_version_number"}},[_c('el-input',{attrs:{"placeholder":"请输入 百旺编码版本号"},model:{value:(_vm.form.code_version_number),callback:function ($$v) {_vm.$set(_vm.form, "code_version_number", $$v)},expression:"form.code_version_number"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票收款人","prop":"ticket_payee"}},[_c('el-input',{attrs:{"placeholder":"请输入 收款人"},model:{value:(_vm.form.ticket_payee),callback:function ($$v) {_vm.$set(_vm.form, "ticket_payee", $$v)},expression:"form.ticket_payee"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票复核人","prop":"ticket_reviewer"}},[_c('el-input',{attrs:{"placeholder":"请输入 复核人"},model:{value:(_vm.form.ticket_reviewer),callback:function ($$v) {_vm.$set(_vm.form, "ticket_reviewer", $$v)},expression:"form.ticket_reviewer"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin":"0 0 0 50px"},attrs:{"type":"primary","native-type":"submit"}},[_vm._v("保存\n          ")])],1)])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/taxPanel.9679f6ac26ff326dd0c5.js